import {DatePipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ConfirmationService, MenuItem} from 'primeng/api';
import {IntegradorService} from '../../../../services/integrador.service';
import {ToastService} from '../../../../services/toast.service';
import {Instancia} from '../../../../types/Instancia.type';
import {NotaFiscal} from '../../../../types/notafiscal.type';


interface Filtro {
  id: string;
  nome: string;
}

@Component({
  selector: 'app-notafiscals',
  templateUrl: './notafiscals.component.html',
  styleUrl: './notafiscals.component.css',
  providers: [DatePipe, ConfirmationService],
})
export class NotaFiscalsComponent implements OnInit {
  itensReversao: MenuItem[];

  notaFiscals!: NotaFiscal[];
  notasSelecionadas: NotaFiscal[] = [];

  loading: boolean = false;
  loadingInteg: boolean = false;
  loadingSincronizar: boolean = false;
  dateInicio: Date | undefined;
  dateFim: Date | undefined;
  rangeDates!: string;
  instancias: Instancia[] = [
    {id: 'VALE', nome: 'VALE'},
    {id: 'UCP', nome: 'UCP'},
    {id: 'UVP', nome: 'UVP'},
  ];
  instanciaSelecionada!: string;

  processos: Instancia[] = [
    {id: 'MENSAL', nome: 'MENSAL'},
    {id: 'MENSAL_REVENDA', nome: 'MENSAL REVENDA'},
    {id: 'REVENDA_COMPLEMENTAR', nome: 'REVENDA COMPLEMENTAR'},
    {id: 'MENSAL_COMPLEMENTAR', nome: 'MENSAL COMPLEMENTAR'},
  ];

  status: any[] = [ {name: 'Integrado', value: 'IT' }
    , {name: 'Erro', value: 'ER'}
    , {name: 'Cancelado', value: 'CA'}
    , {name: 'Estornado', value: 'ES'}
    , {name: 'Aguardando Emissão', value: 'AE'}
    , {name: 'Pendente Integração', value: 'IE'}
  ]

  statusTaxa: any[] = [ {name: 'Integrado', value: 'IT' }
    , {name: 'Erro', value: 'ER'}
    , {name: 'Cancelado', value: 'CA'}
    , {name: 'Estornado', value: 'ES'}
    , {name: 'Pendente Integração', value: 'NI'}
  ]

  fornecedores: Filtro[] = [];
  fazendas: Filtro[] = [];
  taxas: Filtro[] = [];

  constructor(
    private integradorService: IntegradorService,
    private toastService: ToastService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService
  ) {
    this.itensReversao = [
      {
        label: 'Nota Fiscal',
        items: [
          {
            label: 'Cancelar',
            icon: 'pi pi-times',
            command: () => {
              this.cancelar();
            },
          },
          {
            label: 'Estornar no PIMS',
            icon: 'pi pi-undo',
            command: () => {
              this.estornar();
            },
          },
        ]
      },{
        label: 'Taxas',
        items: [
          {
            label: 'Cancelar',
            icon: 'pi pi-times',
            command: () => {
              this.cancelarTaxa();
            },
          },
        ]
      },

    ];
  }

  ngOnInit() {
  }

  getNotaFiscals() {
    this.loading = true;

    this.notasSelecionadas = [];

    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined
    ) {
      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

      this.integradorService
        .getNotaFiscals(this.instanciaSelecionada, dataInicial, dataFinal)
        .subscribe({
          next: (data) => {
            this.notaFiscals = data;

            const cdFornecs = [...new Set(this.notaFiscals.map(nf => nf.cdFornecErp))];
            this.fornecedores = cdFornecs.map(fornec => ({id: fornec, nome: fornec}))

            const cdFazendas = [...new Set(this.notaFiscals.map(nf => nf.fazenda))];
            this.fazendas = cdFazendas.map(fazenda => ({id: fazenda, nome: fazenda}))

            const cdTaxas = [...new Set(this.notaFiscals.map(nf => nf.descTaxa))];
            this.taxas = cdTaxas.map(taxa => ({id: taxa, nome: taxa}))

          },
          error: (error) => {
            this.toastService.erro(
              error.error.title,
              'Erro ao buscar: ' + error.error.detail
            );
          },
          complete: () => {
            this.loading = false;
          },
        });
    } else {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários');
      this.loading = false;
    }
  }

  sincronizar() {
    this.notasSelecionadas = [];

    if (this.instanciaSelecionada == undefined) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }

    this.loadingSincronizar = true;
    this.loading = true;

    let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    this.integradorService
      .postSolicitaNotaFiscal(this.instanciaSelecionada, dataInicial, dataFinal)
      .subscribe({
        next: (value) => {
          this.toastService.sucesso('Sucesso', 'Busca realizada');
        },
        error: (err) => {
          this.toastService.erro(
            'Erro',
            'Erro na solicitação: ' + err.error.message
          );
        },
        complete: () => {
          this.loadingSincronizar = false;
          this.loading = false;
          this.getNotaFiscals();
        },
      });
  }

  integrar() {
    if (this.instanciaSelecionada == undefined) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }

    if (
      this.notasSelecionadas.filter(
        (nf) => nf.fgStatusInteg == 'IT' || nf.fgStatusInteg == 'AE'
      ).length > 0
    ) {
      this.toastService.alerta(
        'Integrada',
        'Existem notas selecionadas que já foram integradas, favor verificar'
      );

      return;
    }

    this.loadingInteg = true;

    let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    console.log(this.notasSelecionadas);

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.integradorService.getIntegraNotaFiscal(corpo).subscribe({
      next: (value) => {
        this.toastService.sucesso('Sucesso', 'Integração realizada');
      },
      error: (err) => {
        this.toastService.erro(
          'Erro',
          'Erro na solicitação: ' + err.error.message
        );
        this.notasSelecionadas = [];
        this.loadingInteg = false;
      },
      complete: () => {
        this.loadingInteg = false;
        this.getNotaFiscals();
        this.notasSelecionadas = [];
      },
    });
  }

  integrarTaxa() {
    if (this.instanciaSelecionada == undefined) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }

    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa == 'IT').length >
      0
    ) {
      this.toastService.alerta(
        'Integrada',
        'Existem notas selecionadas que já foram integradas, favor verificar'
      );

      return;
    }

    this.loadingInteg = true;

    let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.integradorService.postIntegraNotaFiscalTaxa(corpo).subscribe({
      next: (value) => {
        this.toastService.sucesso('Sucesso', 'Integração das taxas realizada');
      },
      error: (err) => {

        console.log(err)

        this.toastService.erro(
          'Erro',
          'Erro na solicitação: ' + err.error
        );
        this.loadingInteg = false;
      },
      complete: () => {
        this.loadingInteg = false;
        //this.getNotaFiscals();
      },
    });
  }

  getDataPipeTransForm(data: string): string | null {
    return this.datePipe.transform(data, 'yyyy-MM-dd');
  }

  exportar() {
    if (this.instanciaSelecionada == undefined) {
      this.toastService.alerta('Instância', 'Selecione uma instância');

      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');

      return;
    }

    if (this.notasSelecionadas.length > 0) {
      this.loadingInteg = true;

      let ids = this.notasSelecionadas.map((m) => m.idNf);

      let corpo = {
        ids: ids,
        usuario: localStorage.getItem('cdUsuarioErp'),
      };

      this.integradorService.exportarNotaFiscal(corpo).subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'data.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        error: (error) => {
          this.toastService.erro('Exportar', 'Erro ao exportar:' + error.error);
          this.loadingInteg = false;
        },
        complete: () => {
          this.loadingInteg = false;
        },
      });
    } else {
      this.toastService.info(
        'Exportar',
        'Necessário selecionar os registros que devem ser exportados'
      );
    }
  }

  cancelar() {
    if (
      this.notasSelecionadas.filter((nf) => nf.fgStatusInteg != 'IT' && nf.fgStatusInteg != 'AE' && nf.fgStatusInteg != 'ER' && nf.fgStatusInteg != 'IE').length >
      0 ||
      this.notasSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros integrados');

      return;
    }

    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa == 'IT').length > 0
    ) {
      console.log("NF Integrada");

      this.confirmaTaxaIntegrada().then(() => {
        this.confirmaCancelamento();
      })

    } else {
      this.confirmaCancelamento()
    }

  }

  private confirmaTaxaIntegrada(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.confirmationService.confirm({
        message: 'Existem taxas integradas das notas selecionadas, você deseja continuar?',
        header: 'Confirmar',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'none',
        acceptButtonStyleClass: 'bg-red-500',
        rejectIcon: 'none',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: () => {
          resolve();
        },
        reject: () => {
          reject();
        }
      });
    });
  }

  confirmaCancelamento() {

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.integradorService.postCancelarNF(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Cancelamento realizado');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
            this.loadingInteg = false;
          },
          complete: () => {
            this.loadingInteg = false;
            this.getNotaFiscals();
            this.notasSelecionadas = [];
          },
        });
      },
    });
  }

  estornar() {
    if (
      this.notasSelecionadas.filter((nf) => nf.fgStatusInteg != 'CA').length >
      0 ||
      this.notasSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros cancelados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.notasSelecionadas.map((m) => m.idNf);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja estornar os itens selecionados no PIMS? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.integradorService.postEstornarNF(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Estorno realizado');
          },
          error: (err) => {
            console.error(err)
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error
            );
            this.loadingInteg = false;
          },
          complete: () => {
            this.loadingInteg = false;
            this.getNotaFiscals();
            this.notasSelecionadas = [];
          },
        });
      },
    });
  }

  cancelarTaxa() {
    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa != 'IT' && nf.statusIntegTaxa != 'CA' && nf.statusIntegTaxa != 'NI').length >
      0 ||
      this.notasSelecionadas.length == 0
    ) {
      this.toastService.alerta('', 'Status atual não possibilita o cancelamento, favor verificar.');

      return;
    }

    if (
      this.notasSelecionadas.filter((nf) => nf.statusIntegTaxa == 'IT').length > 0
    ) {

      this.confirmationService.confirm({
        message: 'Existem taxas selecionadas que já estâo integradas, você deseja continuar o cancelamento?',
        header: 'Confirmar',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'none',
        acceptButtonStyleClass: 'bg-red-500',
        rejectIcon: 'none',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: () => {

          setTimeout(() => {
            this.confirmaTaxaCancelamento();
          }, 1000);
        },
      });
    }else{

    this.confirmaTaxaCancelamento();
    }


  }

  confirmaTaxaCancelamento() {

    let taxas = this.notasSelecionadas.map((m) => ({idNf: m.idNf, taxa: m.descTaxa}) );

    let corpo = {
      taxas: taxas,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.integradorService.postCancelarTaxa(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Cancelamento realizado');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
            this.loadingInteg = false;
          },
          complete: () => {
            this.loadingInteg = false;
            this.getNotaFiscals();
            this.notasSelecionadas = [];
          },
        });
      },
    });
  }
}
